import { render, staticRenderFns } from "./vgb-tab.vue?vue&type=template&id=66068b0b"
import script from "./vgb-tab.ts?vue&type=script&lang=js&external"
export * from "./vgb-tab.ts?vue&type=script&lang=js&external"
import style0 from "./vgb-tab.less?vue&type=style&index=0&lang=less&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66068b0b')) {
      api.createRecord('66068b0b', component.options)
    } else {
      api.reload('66068b0b', component.options)
    }
    module.hot.accept("./vgb-tab.vue?vue&type=template&id=66068b0b", function () {
      api.rerender('66068b0b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/event/event-info/tabs/vgb-tab/vgb-tab.vue"
export default component.exports